<template>
  <div class="raffles h-100">
    <va-card
      v-if="$apollo.queries.raffles.loading"
      class="h-100"
    >
      <div class="row h-100" >
        <div class="flex xs12 h-100">
          <div
            class="flex-center va-flex-center h-100"
          >
            <OrbitSpinner
              :animation-duration="1500"
              :color="'#e34b4a'"
              :size="300"
            />
          </div>
        </div>
      </div>
    </va-card>
    <div
      v-else
      class="flex xs12"
    >
      <va-card
      >
        <template v-if="raffles.authorization_number !== '' && raffles.authorization_number !== null && raffles.authorization_number !== '-'" slot="actions">
          <p>Nº Autorização: {{raffles.authorization_number}}</p>
        </template>
        <div class="row">
          <div
            class="flex xs12 centro"
          >
            <p class="display-1 pb-4 pt-2">
              {{raffles.name}}
            </p>
          </div>
        </div>
        <div class="row">
          <div
            class="flex xs4"
          >
            <img
              :src="$store.getters['environment/cdn'] + '/raffles/' + raffles.image"
              style="width: 100%;"
            >
          </div>
          <div
            class="flex xs8"
          >
            <div class="py-4 flex-all" style="justify-content: space-between !important;">
              <p class="display-1 flex xs9 align_center">
                Prêmios do Sorteio
              </p>
              <p class="display-1 flex xs2 align_center">
                {{raffles.prizes.length > 1 ? 'Ganhadores':'Ganhador'}}
              </p>
              <p class="display-1 flex xs2 align_center" style="padding-left: 30px;">
                {{raffles.prizes.length > 1 ? 'Cupons':'Cupom'}}
              </p>
            </div>
            <div v-for="(prize, idx) in raffles.prizes" :key="idx" class="py-4 flex-all justify-between">
              <p class="display-1 flex-all align_center">
                {{idx+1}}º Prêmio - {{prize.name}}
              </p>
              <va-button
                color="success"
                @click="open(prize)"
                large
                v-if="!prize.request && prize.rwa.ag.count == 0"
              >
                {{ $t('raffles.raffle.btn')}}
              </va-button>
              <div
                v-else-if="(prize.request && prize.response && prize.response.msg !== 'danger') || prize.rwa.ag.count > 0"
              >
                <div class="display-1 flex-all align_center">
                  {{ prize.rwa.ag.count === 0
                    ? prize.response.client.firstName + ' ' + prize.response.client.lastName
                    : prize.rw[0].client.firstName + ' ' + prize.rw[0].client.lastName }}
                </div>
                <ticket class="flex-all align_center"
                  :ticket="prize.rwa.ag.count === 0
                    ? prize.response.ticket_id
                    : prize.rw[0].ticket_id"
                />
              </div>
              <va-notification
                v-else
                :color="prize.response.msg"
              >
                <va-badge :color="prize.response.msg">
                  {{ $t('raffles.raffle.' + prize.response.msg)}}
                </va-badge>
                <template v-if="prize.response.msg == 'success'">
                  <p class="pr-1">
                    Codigo do Ganhador:
                  </p>
                  <b v-if="prize.rwa.ag.count === 0">
                    {{prize.response.ticket_id}}
                  </b>
                  <b v-else>
                    {{prize.rw[0].ticket_id}}
                  </b>
                </template>
                <template v-else>
                  Houve um problema ao realizar o Sorteio!
                </template>
              </va-notification>
            </div>
          </div>
        </div>
      </va-card>
      <va-card
        :title="$t('raffles.cards.title-tickets')"
        class="mt-2 mb-5 pb-3"
      >
        <div class="row">
          <div class="flex xs2" v-for="(ticket, idt) in tickets" :key="idt">
            <div class="flex-all justify-center">
              <ticket
                cor="blue"
                :ticket="ticket.ticket_id"
              />
            </div>
          </div>
        </div>
      </va-card>
    </div>
    <va-modal
      v-model="modal"
      :title="$t('raffles.raffle.modalTitle')"
      :hideDefaultActions="true"
      :noEscDismiss="true"
      :noOutsideDismiss="true"
      size='large'
    >
      <odometro
        @terminou='close'
      />
      <template slot="actions">
        <va-button v-show="opcoes" @click="modal = false">Fechar</va-button>
      </template>
    </va-modal>
  </div>
</template>
<script>
import Odometro from './odometro/odometro'
import { OrbitSpinner } from 'epic-spinners'
import gql from 'graphql-tag'
import Ticket from './Ticket'
export default {
  name: 'raffle',
  components: {
    OrbitSpinner,
    Ticket,
    Odometro,
  },
  props: {
    raffle: {
      required: false,
    },
  },
  methods: {
    open (prize) {
      this.modal = true
      this.actualPrize = prize
      this.actualResponse = null
      this.opcoes = false
      const self = this
      const { dispatch } = self.$store
      this.$axios.post(
        '/api/winner',
        {
          raffle_id: this.raffles.id,
          prize_id: prize.id,
        },
      )
        .then(response => {
          self.actualResponse = {
            msg: 'success',
            ...response.data,
          }
          dispatch('raffle/ReqResp', {
            request: true,
            response: self.actualResponse,
          })
        })
        .catch(e => {
          self.actualResponse = {
            msg: 'danger',
          }
          dispatch('raffle/ReqResp', {
            request: true,
            response: self.actualResponse,
          })
        })
    },
    close (v) {
      this.opcoes = v
      this.actualPrize.request = true
      this.actualPrize.response = this.actualResponse
    },
  },
  data () {
    return {
      raffles: {},
      tickets: {},
      titleCard: '',
      modal: false,
      actualPrize: null,
      actualResponse: null,
      opcoes: false,
      palavra: '',
    }
  },
  apollo: {
    raffles: {
      query: gql`
      query MyQuery($id: Int!) {
        raffles: raffle_by_pk(id: $id) {
          id
          name
          datetime
          authorization_number
          image
          prizes {
            id
            name
            image
            description
            rw: raffle_winners(where: {active: {_eq: true}}) {
              ticket_id
              client {
                firstName
                lastName
              }
            }
            rwa: raffle_winners_aggregate(where: {active: {_eq: true}}) {
              ag: aggregate {
                count
              }
            }
          }
        }
      }
      `,
      variables () {
        return {
          id: this.raffle,
        }
      },
      result ({ data, loading }) {
        if (!loading) {
          data.raffles.prizes.forEach((element, i) => {
            element.request = false
            element.response = { msg: 'success' }
          })
        }
      },
    },
    tickets: {
      query: gql`
      query MyQuery($raffle_id: Int) {
        tickets: raffle_ticket(where: {raffle_id: {_eq: $raffle_id}}) {
          id
          ticket_id
        }
      }
      `,
      variables () {
        return {
          raffle_id: this.raffle,
        }
      },
    },
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('raffles')) {
      this.$apollo.queries.raffles.refetch()
    }
  },
}
</script>

<style lang="scss">
.centro {
  text-align: center;
}

.va-card__body {
  overflow-x: unset;
}

.h-100 > div {
  height: 100%;
}

.va-notification {
  &__content {
    flex-direction: column !important;
  }
}
</style>
<style lang="scss" scoped>
.h-100 {
  height: 100%;
}

.display-1 {
  font-size: 2rem;
}

.va-notification {
  margin: 0;

  &__content {
    flex-direction: column !important;
  }
}

.flex-all {
  display: flex;
}

.flex-all > * {
  display: flex;
}

.align_center {
  align-items: center;
}

.justify-between {
  justify-content: space-between;
}

.justify-center {
  justify-content: center;
}
</style>
